import { useEffect, useRef } from 'react'

/**
 * React hook that executes a function only once during the component lifecycle
 * @param {() => void} fn - The function to execute once
 * @returns {null}
 * @description Ensures the provided function runs only once, even if the component re-renders
 */
export const useOnce = (fn) => {
  const triggered = useRef(false)

  useEffect(() => {
    if (!triggered.current) {
      fn()
      triggered.current = true
    }
  }, [fn])

  return null
}
